import React from 'react';
import {useForm, FormProvider} from 'react-hook-form';

import {isBordomatikBox} from 'client/common/types';

import {useModal} from 'client/common/hooks/modal';
import {useScrollToError} from 'client/common/hooks/errors';

import ConstructorPublicationButton from 'client/common/components/publication/constructor-publication-button';
import CreativeModerationModal from 'client/creatives/components/creative-moderation-modal';

import {BordomatikFormValues, CreativeFormValues, SettingsFormProps} from './types';

import CreativeForm from './creative-form';
import BordomatikForm from './bordomatik-form';

import './creative-settings.css';

export default function SettingsForm(props: SettingsFormProps) {
    const {box, survey, disabled, creative, isPayed, updateSurveyBoxContext} = props;
    const {state, name, slug} = survey;
    const FormComponent = isBordomatikBox(box) ? BordomatikForm : CreativeForm;

    const defaultValues = isBordomatikBox(box)
        ? BordomatikForm.getDefaultValue(box, name)
        : CreativeForm.getDefaultValue(box, name);

    const formMethods = useForm<CreativeFormValues | BordomatikFormValues>({
        mode: 'onTouched',
        defaultValues
    });

    const [showModal, hideModal] = useModal();

    useScrollToError();

    const handleModeration = () => {
        if (creative.service === 'youtube' && state === 'DRAFT') {
            showModal(<CreativeModerationModal onSubmit={hideModal} />, {withCross: true});
        }
    };

    const handlePublishClick = async (publishCallback: () => Promise<void>) => {
        // показываем попап публикации после прохождения валидации формы
        await formMethods.handleSubmit(publishCallback)();
    };

    return (
        <form>
            <FormProvider {...formMethods}>
                <FormComponent
                    slug={slug}
                    // @ts-ignore
                    box={box}
                    name={name}
                    state={state}
                    disabled={disabled}
                    creative={creative}
                    updateSurveyBoxContext={updateSurveyBoxContext}
                />
            </FormProvider>
            {(!disabled || !isPayed) && (
                <ConstructorPublicationButton
                    survey={survey}
                    onClick={handlePublishClick}
                    onModeration={handleModeration}
                />
            )}
        </form>
    );
}
